// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"214":"90f5478f","705":"98ecf8e9"}[chunkId] + ".css";
};